import React from 'react';
import powformLogo from "../../assets/images/powform-logo.svg";
import {FooterCopyright,FooterInner,FooterLogo,FooterLogoImg,Root} from '../../styles/jss/components/footer';

const Footer = () => {

    return (
        <Root>
            <FooterInner maxWidth="md" >
                <FooterCopyright >Created by</FooterCopyright>
                <FooterLogo href={process.env.REACT_APP_SERVICE_URL}  title="Powform">
                    <FooterLogoImg src={powformLogo} alt="Powform logo"  />
                </FooterLogo>
            </FooterInner>
        </Root>
    );
}

export default Footer;
